<template lang="pug">
  v-container.fill-height.align-center.pa-0.justify-center(max-width="600px")
    v-card(flat width="800px" class="rounded-card mx-auto" d-flex justify-center)
      v-snackbar( v-model="snackBar" :color="snackBarColor" ) {{ snackBarMessage }}
        template( v-slot:action="{attrs}")
          v-btn(text v-bind="attrs" @click="snackBar = false")
            v-icon fas fa-times
      DeleteTokenDialog(
        v-if="showControlDeleteDialog"
        :show="showControlDeleteDialog"
        @close="closeDeleteDialog"
        @yes="onDeleteKeyClick"
        :selectedKey="selectedKey"
        :indexClicked="indexClicked"
        )
      v-container(v-if="!isFetchInProgress")
        v-row.ma-0
          v-toolbar.elevation-0
            v-btn(
              color="primary"
              @click="onAddNewKeyClick"
              :loading="fetchInProgress"
              :disabled="fetchInProgress && isDeleteInProgress && isFetchInProgress" ) {{ $t('settingsPage.addNewKeyButtonLabel') }}
        v-row.text-center.title(v-if="apiList.length < 1")
          v-col.text-center(cols="12") {{ $t('settingsPage.anyKeyTitle') }}
        v-row.ma-0.mt-4(v-else  v-for="(item,idx) in apiList" :key="idx" :disabled="fetchInProgress")
          v-col(cols="12" v-if="$vuetify.breakpoint.mdAndUp")
            v-card(width="500px")
              v-card-text.pb-0
                v-textarea.mb-0(outlined v-model="item.token" readonly :value="item.token")
              v-card-actions.pt-0
                v-row.ma-0.mb-2
                  v-btn.ml-2(color="error"
                    :loading="isDeleteInProgress && indexClicked === idx" @click="onDeleteButtonClick(item, idx)"
                    :disabled="fetchInProgress") {{ $t('settingsPage.deleteButtonLabel') }}
                  v-spacer
                  v-btn.mr-2(color="primary" :disabled="fetchInProgress" @click="onCopyButtonClick(item.token)")
                    v-icon fas fa-copy
          v-col.pa-0(cols="12" v-else)
            v-card.ma-0(height="250px" )
              v-card-text.pb-0
                v-textarea.mb-0(outlined v-model="item.token" readonly :value="item.token")
              v-card-actions.pt-0
                v-row.ma-0
                  v-btn.ml-2(color="error"
                    :loading="isDeleteInProgress && indexClicked === idx" @click="onDeleteButtonClick(item, idx)"
                    :disabled="fetchInProgress && indexClicked === idx") {{ $t('settingsPage.deleteButtonLabel') }}
                  v-spacer
                  v-btn.mr-2(color="primary" :disabled="fetchInProgress" @click="onCopyButtonClick(item.token)")
                    v-icon fas fa-copy
      v-skeleton-loader(v-if="isFetchInProgress"
        type="list-item@12"
        width="100%")
</template>

<script lang="ts">
import Vue from 'vue'
import {Component} from 'vue-property-decorator'
import {Action} from "vuex-class";
import {DELETE_KEY, GET_API_KEY, SAVE_NEW_KEY} from "@/store/action-types";
import DeleteTokenDialog from "@/components/settings/DeleteTokenDialog.vue";
import ApiKey from "@/model/ApiKey";

@Component({
  components: {
    DeleteTokenDialog
  }
})
export default class ApiKeyPage extends Vue {

  @Action(SAVE_NEW_KEY) saveNewKey!: ({ (): Promise<void> })
  @Action(GET_API_KEY) fetchApiKey!: ({ (): Promise<ApiKey[]> })
  @Action(DELETE_KEY) deleteSelectedKey!: ({ (payload: string): Promise<any> })

  private fetchInProgress: boolean = false
  private isDeleteInProgress: boolean = false
  private isFetchInProgress: boolean = false
  private snackBar: boolean = false
  private snackBarMessage: string = ''
  private snackBarColor: string = ''
  private apiList: ApiKey[] = [ ]
  private selectedKey: any | null = null
  private showControlDeleteDialog: boolean = false
  private indexClicked: undefined = undefined

  onDeleteButtonClick(item: any,index: any) {
    this.selectedKey = item
    this.indexClicked = index
    this.showControlDeleteDialog = true
  }

  closeDeleteDialog() {
    this.showControlDeleteDialog = false
  }

  onCopyButtonClick (item: any){
    this.fetchInProgress = true
     navigator.clipboard.writeText(item).then(function() {
    })
    this.fetchInProgress = false
      this.snackBar = true
      this.snackBarColor="success"
      this.snackBarMessage=this.$t('settingsPage.copyKey').toString()
  }

  async onDeleteKeyClick(item: any,idx: any): Promise<void> {
    const payload: string = item.id
    this.indexClicked = idx

    try {
      this.isDeleteInProgress = true
      await this.deleteSelectedKey(payload)
      this.isDeleteInProgress = false
      this.showControlDeleteDialog = false
      this.fetchData()

    } catch (e) {
      this.snackBar = true
      this.snackBarColor="error"
      this.snackBarMessage=this.$t('settingsPage.snackbarDataErrorMessage').toString()
    }finally {
      this.snackBar = true
      this.snackBarColor="success"
      this.snackBarMessage=this.$t('settingsPage.deleted').toString()
    }
  }

  async onAddNewKeyClick(): Promise<void> {
    this.fetchInProgress = true
    try {
      await this.saveNewKey()
      this.fetchData()
      this.fetchInProgress = false
    } catch (e) {
      this.snackBar = true
      this.snackBarColor="error"
      this.snackBarMessage=this.$t('settingsPage.snackbarKeyErrorMessage').toString()
    }finally {
      this.snackBar = true
      this.snackBarColor="success"
      this.snackBarMessage=this.$t('settingsPage.keyAdded').toString()
    }
  }

  async fetchData(): Promise<void> {
    try {
      this.isFetchInProgress = true
      this.apiList = await this.fetchApiKey()
    } catch (e) {
      this.snackBar = true
      this.snackBarColor="error"
      this.snackBarMessage=this.$t('settingsPage.offerStructure.snackbarErrorMessage').toString()
    }finally {
      this.isFetchInProgress = false
    }
  }

  mounted ()  {
    this.fetchData()
  }
}
</script>

<style lang="stylus" scoped>

</style>
